export default class FieldValidator {

    constructor(field, document) {
        this.field = field
        this.document = document
    }

    isValid() {

        let fieldValue = this.document[this.field.index]

        if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
            return false
        }

        if (this.field.field_type === 'Number' && !this.isValidNumber(fieldValue)) {
            return false
        }

        if (this.field.name.toLowerCase().indexOf('email') > -1) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValue)
        }


        return true
    }

    isValidNumber(fieldValue) {
        return !isNaN(fieldValue)
    }
}